/* ==========================================================================
   NuBest account drawer — behaviour layer (v2.1)
   Works on top of the theme drawer core (T4SThemeSP.Drawer) and the markup in sections/login-sidebar.liquid.
   - The theme replaces the drawer's HTML after load/cache, so everything is delegated from document.
   - Forms are real Shopify forms and POST natively. This file only validates inline, then lets the browser submit.
   - Never reads, stores or sends credentials itself.
   Plain ES5 on purpose (older iOS Safari).
   ========================================================================== */
(function () {
  'use strict';

  var DRAWER_ID = 't4s-login-sidebar';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var lastTrigger = null;
  var resetTimer = null;

  function drawer() { return document.getElementById(DRAWER_ID); }
  function root() { var d = drawer(); return d ? d.querySelector('[data-nb-acct]') : null; }
  function q(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function closest(el, sel) {
    while (el && el.nodeType === 1) {
      if ((el.matches || el.msMatchesSelector || el.webkitMatchesSelector).call(el, sel)) return el;
      el = el.parentNode;
    }
    return null;
  }
  function inDrawer(el) { var d = drawer(); return !!(d && el && d.contains(el)); }
  function isOpen() { var d = drawer(); return !!d && d.getAttribute('aria-hidden') === 'false'; }
  function isFinePointer() {
    return !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  }
  function focusEl(el) {
    if (!el || !el.focus) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }
  function visible(el) { return el.getClientRects().length > 0; }
  function msg(r, key) { return r.getAttribute('data-msg-' + key) || ''; }

  /* ---------- views / tabs ---------- */
  function showView(r, name) {
    var found = null;
    qa('[data-nb-view]', r).forEach(function (v) {
      var on = v.getAttribute('data-nb-view') === name;
      v.hidden = !on;
      if (on) found = v;
    });
    if (!found) return false;
    var title = q('#nb-acct-title', r);
    if (title && found.getAttribute('data-nb-title')) title.textContent = found.getAttribute('data-nb-title');
    var back = q('.nb-back', r);
    if (back) back.hidden = name !== 'recover';
    var sc = q('.nb-acct-scroll', r);
    if (sc) sc.scrollTop = 0;
    return true;
  }

  function showTab(r, name) {
    qa('[role="tab"]', r).forEach(function (t) {
      var on = t.getAttribute('data-nb-tab') === name;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    var pl = q('#nb-pane-login', r), pr = q('#nb-pane-register', r);
    if (pl) pl.hidden = name !== 'login';
    if (pr) pr.hidden = name !== 'register';
  }

  function go(r, to) {
    if (to === 'recover') {
      var le = q('#nb-login-email', r), re = q('#nb-recover-email', r);
      if (le && re && le.value.replace(/^\s+|\s+$/g, '') && !re.value) re.value = le.value.replace(/^\s+|\s+$/g, '');
      if (!showView(r, 'recover')) return;
      setTimeout(function () { focusEl(isFinePointer() ? re : q('.nb-back', r)); }, 30);
    } else {
      if (!showView(r, 'guest')) return;
      showTab(r, 'login');
      setTimeout(function () { focusEl(isFinePointer() ? q('#nb-login-email', r) : q('#nb-tab-login', r)); }, 30);
    }
  }

  function reset(r) {
    if (r.getAttribute('data-nb-state') === 'guest') {
      showView(r, 'guest');
      showTab(r, 'login');
    }
    qa('input[aria-invalid="true"]', r).forEach(function (i) { setErr(i, ''); });
    qa('.nb-pw input', r).forEach(function (i) { if (i.type !== 'password') toggleType(r, i, false); });
    qa('.nb-aform', r).forEach(function (f) { f.className = f.className.replace(/\s*\bis-busy\b/, ''); });
    var sc = q('.nb-acct-scroll', r);
    if (sc) sc.scrollTop = 0;
  }

  /* ---------- password show / hide ---------- */
  function toggleType(r, input, show) {
    var btn = q('[data-nb-pw="' + input.id + '"]', r);
    input.type = show ? 'text' : 'password';
    if (btn) {
      btn.textContent = show ? r.getAttribute('data-txt-hide') : r.getAttribute('data-txt-show');
      btn.setAttribute('aria-pressed', show ? 'true' : 'false');
      btn.setAttribute('aria-label', show ? r.getAttribute('data-label-hide') : r.getAttribute('data-label-show'));
    }
  }

  /* ---------- inline validation ---------- */
  function setErr(input, text) {
    var p = document.getElementById(input.id + '-err');
    input.setAttribute('aria-invalid', text ? 'true' : 'false');
    if (p) p.textContent = text || '';
  }

  function ruleError(r, input) {
    var rule = input.getAttribute('data-v');
    var v = input.value.replace(/^\s+|\s+$/g, '');
    if (rule === 'email') {
      if (!v) return msg(r, 'email-empty');
      return EMAIL_RE.test(v) ? '' : msg(r, 'email-bad');
    }
    if (rule === 'password') return input.value ? '' : msg(r, 'pw-empty');
    if (rule === 'newpw') {
      var min = parseInt(r.getAttribute('data-min-pw'), 10) || 8;
      if (!input.value) return msg(r, 'newpw-empty');
      return input.value.length >= min ? '' : msg(r, 'newpw-short');
    }
    if (rule === 'first') return (r.getAttribute('data-require-first') === '1' && !v) ? msg(r, 'first') : '';
    return '';
  }

  function validate(r, form) {
    var firstBad = null;
    qa('[data-v]', form).forEach(function (input) {
      var err = ruleError(r, input);
      setErr(input, err);
      if (err && !firstBad) firstBad = input;
    });
    if (firstBad) { focusEl(firstBad); return false; }
    return true;
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var trig = closest(e.target, '[data-drawer-options]');
    if (trig && /t4s-login-sidebar/.test(trig.getAttribute('data-drawer-options') || '')) lastTrigger = trig;

    var el = closest(e.target, '[data-nb-go],[data-nb-tab],[data-nb-pw]');
    if (!el || !inDrawer(el)) return;
    var r = root();
    if (!r) return;

    if (el.hasAttribute('data-nb-go')) {
      e.preventDefault();
      go(r, el.getAttribute('data-nb-go'));
    } else if (el.hasAttribute('data-nb-tab')) {
      e.preventDefault();
      var name = el.getAttribute('data-nb-tab');
      showTab(r, name);
      setTimeout(function () {
        var pane = q(name === 'register' ? '#nb-pane-register' : '#nb-pane-login', r);
        var first = pane && q('input:not([type="checkbox"]):not([type="hidden"])', pane);
        focusEl(first && isFinePointer() ? first : q('#nb-tab-' + name, r));
      }, 30);
    } else if (el.hasAttribute('data-nb-pw')) {
      var input = document.getElementById(el.getAttribute('data-nb-pw'));
      if (!input) return;
      toggleType(r, input, input.type === 'password');
      focusEl(input);
    }
  }, true);

  document.addEventListener('input', function (e) {
    var i = e.target;
    if (i && i.getAttribute && i.getAttribute('aria-invalid') === 'true' && inDrawer(i)) setErr(i, '');
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.className || !/\bnb-aform\b/.test(form.className) || !inDrawer(form)) return;
    var r = root();
    if (!r) return;
    if (!validate(r, form)) { e.preventDefault(); e.stopPropagation(); return; }
    qa('input[data-v="email"]', form).forEach(function (i) { i.value = i.value.replace(/^\s+|\s+$/g, ''); });
    if (!/\bis-busy\b/.test(form.className)) form.className += ' is-busy';
    form.setAttribute('aria-busy', 'true');
  }, true);

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    qa('.nb-aform.is-busy').forEach(function (f) {
      f.className = f.className.replace(/\s*\bis-busy\b/, '');
      f.removeAttribute('aria-busy');
    });
  });

  document.addEventListener('keydown', function (e) {
    var k = e.key || e.keyCode;
    var r = root();
    if (!r || !isOpen()) return;

    /* tabs: arrow keys, Home, End */
    var tab = closest(e.target, '[role="tab"]');
    if (tab && inDrawer(tab)) {
      var names = ['login', 'register'];
      var cur = names.indexOf(tab.getAttribute('data-nb-tab'));
      var next = -1;
      if (k === 'ArrowRight' || k === 39) next = (cur + 1) % 2;
      else if (k === 'ArrowLeft' || k === 37) next = (cur + 1) % 2;
      else if (k === 'Home' || k === 36) next = 0;
      else if (k === 'End' || k === 35) next = 1;
      if (next > -1) {
        e.preventDefault();
        showTab(r, names[next]);
        focusEl(q('#nb-tab-' + names[next], r));
        return;
      }
    }

    /* focus trap */
    if (k !== 'Tab' && k !== 9) return;
    var d = drawer();
    var f = qa('a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]', d).filter(function (el) {
      return el.tabIndex !== -1 && visible(el);
    });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (!d.contains(a)) { e.preventDefault(); focusEl(e.shiftKey ? last : first); }
    else if (e.shiftKey && a === first) { e.preventDefault(); focusEl(last); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); focusEl(first); }
  });

  /* ---------- drawer open / close (CustomEvents dispatched by T4SThemeSP.Drawer) ---------- */
  function whenReady(cb, tries) {
    var r = root();
    if (r) { cb(r); return; }
    if ((tries || 0) > 20) return; /* the section is still loading; ~2s is plenty */
    setTimeout(function () { whenReady(cb, (tries || 0) + 1); }, 100);
  }

  document.addEventListener(DRAWER_ID + '-open', function () {
    if (resetTimer) { clearTimeout(resetTimer); resetTimer = null; }
    whenReady(function (r) {
      setTimeout(function () {
        var target = null;
        if (isFinePointer() && r.getAttribute('data-nb-state') === 'guest') {
          var view = q('[data-nb-view]:not([hidden])', r);
          target = view && q('.nb-acct-pane:not([hidden]) input:not([type="checkbox"]):not([type="hidden"])', view);
        }
        focusEl(target || q('[data-drawer-close]', r));
      }, 60);
    });
  });

  document.addEventListener(DRAWER_ID + '-close', function () {
    var r = root();
    if (r) { /* wait for the slide-out so the view does not visibly jump */
      if (resetTimer) clearTimeout(resetTimer);
      resetTimer = setTimeout(function () { resetTimer = null; if (!isOpen()) reset(r); }, 560);
    }
    if (lastTrigger && document.body.contains(lastTrigger) && visible(lastTrigger)) focusEl(lastTrigger);
    lastTrigger = null;
  });
})();
